import React, {Component} from "react";
import {Link} from "react-router-dom";
import flow1 from "../../../../../assets/img/flow1.png";
import './Spec.css';
import pcbColor from "../../../../../assets/img/pcbColor.png";
import goldFinger from "../../../../../assets/img/goldFingers.png";
import panelby1 from "../../../../../assets/img/panelby1.png";
import panelby2 from "../../../../../assets/img/panelby2.png";


class Spec extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        return (

            <div className="begin-div">
                <div className="spec-background-div font-size-14">
                    <p className="title font-size-30">用語説明</p>
                    {/*<p className="title font-size-30">製造基準書</p>*/}
                    <table className="table table-bordered">
                        {/*<thead>*/}
                        {/*<tr>*/}
                        {/*<th scope="col">日本語</th>*/}
                        {/*<th scope="col">説明内容</th>*/}
                        {/*</tr>*/}
                        {/*</thead>*/}
                        <tbody>
                        <tr>
                            <td className="col-md-3">層数</td>
                            <td>
                                <a href="https://jlcpcb.com/quote/pcbOrderFaq/PCB%20Stackup" target="_blank">
                                    {/*JLCPCBのリンク先の図を参考に制作*/}
                                    インピーダンス制御基板 資料
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td className="col-md-3">サイズ</td>
                            <td>
                                <div className="divcontent3">

                                    <ul> 当社製造可能サイズ
                                    </ul>
                                    <ul> 片面・両面基板については
                                    </ul>
                                    <ul> 最小5mm×5mmから400mm×500mmサポートしております。
                                    </ul>
                                    <ul> 4層・6層基板については
                                    </ul>
                                    <ul> 最小5mm×5mmから300mm×300mmポートしております。
                                    </ul>
                                    <ul> 板厚による製造可能サイズについて
                                    </ul>
                                </div>
                                <table className="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th scope="col">板厚</th>
                                        <th scope="col">層数</th>
                                        <th scope="col">製造可能サイズ</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>ｔ1.0からt1.6mm</td>
                                        <td>片面・両面基板</td>
                                        <td>最小5mm×5mm 最大400mm×500mm</td>
                                    </tr>
                                    <tr>
                                        <td>ｔ1.6からt1.6mm</td>
                                        <td>4層・6層基板</td>
                                        <td>最小5mm×5mm 最大300mm×300mm</td>
                                    </tr>
                                    <tr>
                                        <td>ｔ0.4からt0.8mm</td>
                                        <td>片面・両面基板</td>
                                        <td>最小6mm×10mm 最大300mm×300mm</td>
                                    </tr>
                                    <tr>
                                        <td>ｔ0.4からt0.6mm</td>
                                        <td>片面・両面基板</td>
                                        <td>最小10mm×10mm 最大300mm×300mm</td>
                                    </tr>

                                    </tbody>
                                </table>
                                <p>※20mm×20mm以下の場合はフライング検査が対応できません、フライング検査が必要な場合は、20mm×20mm以上確保して下さい。
                                </p>
                            </td>
                        </tr>
                        <tr>

                            <td>枚数</td>
                            <td>最終基板製造コストを削減のため、独自製造ラインを構築しております、お客様にはご不便をおかけしますが、発注枚数はプルダウンメニューに記載しております枚数でお選びください。
                            </td>
                        </tr>
                        <tr>


                            <td>板厚</td>
                            <div className="divcontent2">

                                <td>
                                    <ul>下記、板厚をサポートしております。</ul>
                                    <ul>0.4mm、0.6mm、0.8mm、1.0mm、1.2mm、1.6mm、2.0mm</ul>
                                    <ul> 板厚による公差</ul>
                                    <ul>1.0mm未満の場合、板厚公差は±0.10mmです。</ul>
                                    <ul>1.0mm以上の場合、板厚公差は±10％です。</ul>
                                </td>
                            </div>
                        </tr>
                        <tr>
                            <td>レジスト色</td>
                            <td>
                                <div className="divcontent3">

                                    <ul>レジストインク（ソルダーマスク）の色指定です。なお白いソルダーマスクの場合はシルク印字が黒色、他のカラーの場合、シルク印字は白色となります。</ul>
                                    <ul> ご注意：注文確認後、色を変更することはできません。
                                    </ul>
                                </div>
                                <div className="row">
                                    <img src={pcbColor} className="img-pcbClr" height="250"/>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>表面処理</td>
                            <td>HASL（有鉛はんだレベラー）HASL-RoHs（鉛フリーはんだレベラー）ENIG-RoHs（無電解金メッキ）</td>
                        </tr>
                        <tr>
                            <td>銅厚</td>
                            <td>外層部のみの銅箔の厚さの選択です、内層の銅厚については17.5μです。
                            </td>
                        </tr>
                        <tr>
                            <td>端子仕上げ</td>
                            <td>
                                <div className="divcontent3">

                                    <ul>表面処理オプションでENIGを選択された場合は金メッキで仕上がります。</ul>
                                    <ul>HASLを選択された場合はHASL（有鉛はんだレベラー）で仕上がります。</ul>
                                </div>
                                <img src={goldFinger} className="img-div" height="150"/>
                            </td>
                        </tr>
                        <tr>

                            <td>材料</td>
                            <div className="divcontent2">
                                <td>
                                    <ul>FR-4標準Tg140Cを使用しています。それ以外の材質は対応しておりません。</ul>
                                    {/*<ul> 詳しくはFR-4 Material.pdfをご確認下さい。</ul>*/}
                                    <ul>
                                        KINGBOARD FR-4の材料認証：こちらからダウンロードしてください。
                                    </ul>
                                </td>
                            </div>
                        </tr>
                        <tr>
                            <td>KITCUTでの面付け希望</td>
                            <td>
                                <p>
                                    KITCUによるシート面付けをご希望の場合
                                </p>
                                <div className="row">
                                    <img src={panelby1} className="panelby1" width="400" height="150"/>
                                </div>
                                <p>
                                    下記のシート面付けをご希望の場合、X=5、Y=2と入力して下さい。
                                </p>
                                <div className="row">
                                    <img src={panelby2} className="panelby2" width="150" height="150"/>
                                </div>
                                <div className="divcontent">
                                    <ol>
                                        <li>
                                            次のような場合はVカットによるシート面付けは対応できません。
                                            シートサイズの長さが70mmより小さい場合
                                        </li>
                                        <li>円、長方形、正方形または三角形のような規則的な基板によるシート面付けです
                                            複雑な基板外形の場合は、お客様側にてシート形状データにてご注文お願いします。
                                        </li>
                                        <li>板厚による最大シートサイズ
                                            <ul> t0.6mmの場合 最大100mm×100mm
                                            </ul>
                                            <ul> t0.8から1.2mmの場合 最大200×200mm
                                            </ul>
                                            <ul> t1.6mmの場合 最大300×300mm
                                            </ul>
                                        </li>
                                    </ol>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>捨て基板</td>
                            <td>
                                <p>
                                    捨て基板を付けることにより、実装効率が上がったり、不良を減らすことができます。

                                </p>
                                <p>
                                    Rをつけることにより他の基板へのキズや欠け防止の対策となります。

                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>面付けサイズ</td>
                            <td> 数種類の基板の「面付け」の場合、各基板の単価が下がり、また、捨て基板を設けた面付けをする事で、実装の単価も下がる可能性があります。
                            </td>
                        </tr>
                        <tr>
                            <td>フライング検査</td>
                            <td>
                                <p>
                                    1層・2層基板についてのフライング検査はオプション選択となります。
                                </p>
                                <p> ４層・6層基板については50枚までフライング検査が標準で実施されます。
                                </p>
                                {/*<p> 50枚上の場合は、フライング検査費用が発生します。*/}
                                {/*</p>*/}
                                <p> 50枚までフライング検査が標準で実施されます。

                                </p>
                                <p>50枚上の場合は、フライング検査費用が発生します。
                                </p>


                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>キャスタレーション ホール</p>
                            </td>
                            <td> 基板側面に半円のスルーホール形状を加工しメタライズすることで基板の表裏の導通が取れます。穴のサイズは最小で0.6 mm必要です、穴の間のスペースも最小で0.6 mm必要です。
                            </td>
                        </tr>
                        <tr>
                            <td>異種面付け</td>
                            <td>基板の種類がいくつあるかを選択してください、複数ある場合は異種面付けとなります。</td>
                        </tr>
                        </tbody>
                    </table>


                    {/*/////////////////////////////////////////////////////////////*/}
                    {/*<table className="table table-bordered">*/}
                    {/*<thead>*/}
                    {/*<tr>*/}
                    {/*<th scope="col">日本語</th>*/}
                    {/*<th scope="col">説明内容</th>*/}
                    {/*<th scope="col">説明内容</th>*/}
                    {/*</tr>*/}
                    {/*</thead>*/}
                    {/*<tbody>*/}
                    {/*<tr>*/}
                    {/*<td>Mark</td>*/}
                    {/*<td>Mark</td>*/}
                    {/*<td>Otto</td>*/}
                    {/*</tr>*/}
                    {/*<tr>*/}
                    {/*<td>Jacob</td>*/}
                    {/*<td>Mark</td>*/}
                    {/*<td>@fat</td>*/}
                    {/*</tr>*/}
                    {/*<tr>*/}
                    {/*<td>Jacob</td>*/}
                    {/*<td>Mark</td>*/}
                    {/*<td>@fat</td>*/}
                    {/*</tr>*/}
                    {/*<tr>*/}
                    {/*<td>Jacob</td>*/}
                    {/*<td>Mark</td>*/}
                    {/*<td>@fat</td>*/}
                    {/*</tr>*/}
                    {/**/}
                    {/*</tbody>*/}
                    {/*</table>*/}
                    {/*//////////////////////////////////////////////////////////////////////*/}
                </div>
            </div>

        );
    }


}

export default Spec;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/Spec.js